import type { AnnouncementListDto } from '@setplex/wbs-api-types'
import { createEffect } from 'effector'
import type { ApiEffect } from '../../index.h'

//GET /wbs/api/device/announcements
export const pushAnnouncementsFx: ApiEffect<void, AnnouncementListDto> =
  createEffect()
